import React, { useRef, useEffect } from 'react';
import { getMemberDisplayName, getMemberInitials } from '../utils/memberSession';
import './MemberAccountMenu.css';

const MemberAccountMenu = ({ member, onNavigate, onLogout }) => {
  const [open, setOpen] = React.useState(false);
  const wrapRef = useRef(null);
  const displayName = getMemberDisplayName(member) || member?.email || 'Miembro';
  const initials = getMemberInitials(member);

  useEffect(() => {
    const onDoc = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, []);

  const go = (path) => {
    setOpen(false);
    onNavigate(path);
  };

  const circleLabel =
    member?.member_circle === 'familia'
      ? 'Familia Javiland'
      : member?.member_circle === 'amigo'
        ? 'Amigos Javiland'
        : 'Comunidad Javiland';

  return (
    <div className="member-account-menu" ref={wrapRef}>
      <button
        type="button"
        className="member-account-trigger"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        aria-haspopup="true"
        title={displayName}
      >
        {member?.avatar_data ? (
          <img src={member.avatar_data} alt="" className="member-account-avatar" />
        ) : (
          <span className="member-account-avatar member-account-avatar--initials" aria-hidden>
            {initials}
          </span>
        )}
        <span className="member-account-name">{displayName}</span>
        <i className={`fas fa-chevron-down member-account-chevron ${open ? 'open' : ''}`} aria-hidden />
      </button>

      {open && (
        <div className="member-account-panel" role="menu">
          <div className="member-account-panel-head">
            <span className="member-account-panel-initials">{initials}</span>
            <div>
              <strong>{displayName}</strong>
              <span className="member-account-circle">{circleLabel}</span>
            </div>
          </div>
          <div className="member-account-columns">
            <div className="member-account-col">
              <h4>Mi cuenta</h4>
              <button type="button" onClick={() => go('/perfil')}>Mi cuenta</button>
              <button type="button" onClick={() => go('/perfil')}>Mis pedidos</button>
            </div>
            <div className="member-account-col">
              <h4>Secciones</h4>
              <button type="button" onClick={() => go('/perfil')}>Mis direcciones</button>
              <button type="button" onClick={() => go('/tienda')}>Tienda</button>
              <button type="button" onClick={() => go('/comunidad')}>Comunidad</button>
            </div>
            <div className="member-account-col">
              <h4>Seguridad</h4>
              <button type="button" onClick={() => go('/comunidad/restablecer')}>Cambiar contraseña</button>
              <button type="button" onClick={() => go('/faq-ayuda')}>Soporte</button>
              <button type="button" onClick={() => go('/politicas/privacy')}>Información legal</button>
              <button type="button" className="member-account-logout" onClick={onLogout}>
                Cerrar sesión
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MemberAccountMenu;
